var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.25 32.2298H27.7955V25.2585C27.7955 23.5963 27.7659 21.4583 25.4802 21.4583C23.1622 21.4583 22.8088 23.2697 22.8088 25.1402V32.2298H18.3583V17.8947H22.6288V19.8553H22.6906C23.2845 18.7278 24.7384 17.5386 26.9059 17.5386C31.4169 17.5386 32.25 20.507 32.25 24.3676V32.2298ZM13.3354 15.9369C11.9043 15.9369 10.75 14.7786 10.75 13.3528C10.75 11.9271 11.9043 10.7688 13.3354 10.7688C14.7597 10.7688 15.9167 11.9271 15.9167 13.3528C15.9167 14.7786 14.7597 15.9369 13.3354 15.9369ZM15.5633 32.2298H11.1034V17.8947H15.5633V32.2298ZM21.5 0C9.62528 0 0 9.62528 0 21.5C0 33.3734 9.62528 43 21.5 43C33.3747 43 43 33.3734 43 21.5C43 9.62528 33.3747 0 21.5 0Z",
    fill: "#007AB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInIcon1);
export default __webpack_public_path__ + "static/media/in_icon_1.c374cef9adcc51bbb790ef605ad30b00.svg";
export { ForwardRef as ReactComponent };